export default __webpack_public_path__ + "static/media/delete-gray.ec23f17f.svg";